module.exports = __webpack_public_path__ + "img/logo_app_ecospazio.a53c0ccf.png";